export default {
  menu: 'Purchase suggest',
  title: 'Purchase suggest',

  table: {
    header: {
      select: 'Select',
      image: 'Image',
      barcode: 'Barcode',
      code: 'Code',
      category: 'Category',
      name: 'Title',
      variant: 'Variant',
      score: 'Point',
      totalSold: 'Total sold',
      saleInventory: 'Sale inventory'
    }
  }
}
